var NKTEN_DISABLE_ANIMATIONS = true;

document.addEventListener('DOMContentLoaded', initHeroNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initHeroNkten);
}

function initHeroNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-hero-nkten]')
    : document.querySelector('[data-hero-nkten]');

  const sections = root ? [root] : document.querySelectorAll('[data-hero-nkten]');

  sections.forEach((section) => {
    if (!section || section.dataset.heroNktenInitialized) return;
    section.dataset.heroNktenInitialized = 'true';

    const words = section.querySelectorAll('.hero-nkten__word-inner');
    const sub = section.querySelector('[data-hero-nkten-sub]');
    const actions = section.querySelector('[data-hero-nkten-actions]');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (NKTEN_DISABLE_ANIMATIONS || prefersReducedMotion || !window.gsap) {
      words.forEach((w) => { w.style.opacity = '1'; w.style.transform = 'none'; });
      if (sub) { sub.style.opacity = '1'; sub.style.transform = 'none'; }
      if (actions) { actions.style.opacity = '1'; actions.style.transform = 'none'; }
      return;
    }

    gsap.set(words, { yPercent: 110, opacity: 0 });
    gsap.set([sub, actions], { y: 24, opacity: 0 });

    const tl = gsap.timeline({ defaults: { ease: 'expo.out' } });
    tl.to(words, { yPercent: 0, opacity: 1, duration: 0.9, stagger: 0.06 })
      .to(sub, { y: 0, opacity: 1, duration: 0.7 }, '-=0.5')
      .to(actions, { y: 0, opacity: 1, duration: 0.7 }, '-=0.45');
  });
}
